import Config from './config'

const audio = {
    entries: {},
    atmospheric() {
        if (Config.isMuted) return
        this.scene?.sound.play(`soundTrack${Config.chance.d4()}`, {
            volume: 0.03,
        })
    },
    buttonClick() {
        if (Config.isMuted) return
        this.scene?.sound.play(`soundButtonClick`, {
            volume: 0.03,
        })
    },
    colonize() {
        if (Config.isMuted) return
        this.scene?.sound.play('soundPlanetColonize', {
            volume: 0.1,
        })
    },
    constructionComplete() {
        if (Config.isMuted) return
        this.scene?.sound.play('soundConstructionComplete', {
            volume: 0.05,
        })
    },
    disband() {
        if (Config.isMuted) return
        this.scene?.sound.play('soundShipDisband', {
            volume: 0.07,
        })
    },
    entitySelect() {
        if (Config.isMuted) return
        this.scene?.sound.play('soundEntitySelect1', {
            volume: 0.06,
        })
    },
    lose() {
        if (Config.isMuted) return
        this.scene?.sound.play('soundGameLose', {
            volume: 0.07,
        })
    },
    mine() {
        this.scene?.sound.play('soundPlanetMine', {
            volume: 0.2,
        })
    },
    moveMarker() {
        if (Config.isMuted) return
        this.scene?.sound.play('soundMoveMarker1', {
            volume: 0.06,
        })
    },
    play(key, options) {
        if (Config.isMuted) return
        this.scene?.sound.play(key, {
            volume: options ? options.volume : 1,
        })
    },
    resources(positive) {
        if (Config.isMuted) return
        this.scene?.sound.play(
            positive ? 'soundResourcesAdd' : 'soundResourcesSubtract',
            {
                volume: 0.2,
            }
        )
    },
    scene: null,
    score() {
        if (Config.isMuted) return
        this.scene?.sound.play('soundScore1', {
            volume: 0.02,
        })
    },
    shipDestroy() {
        if (Config.isMuted) return
        this.scene?.sound.play(
            Config.chance.bool() ? 'soundShipExplode1' : 'soundShipExplode2',
            {
                volume: 0.05,
            }
        )
    },
    shipEnterOrbit() {
        if (Config.isMuted) return
        this.scene?.sound.play('soundShipEnterOrbit1', {
            volume: 0.009,
        })
    },
    shipSelect() {
        if (Config.isMuted) return
        this.scene?.sound.play('soundShipSelect1', {
            volume: 0.04,
        })
    },
    shipSensor() {
        if (Config.isMuted) return
        this.scene?.sound.play('soundShipSensor1', {
            volume: 0.03,
        })
    },
    shipShoot() {
        if (Config.isMuted) return
        this.scene?.sound.play('soundShipShoot1', {
            volume: 0.1,
        })
    },
    tractorBeam() {
        if (Config.isMuted) return
        this.scene?.sound.play('soundTractorBeam1', {
            volume: 0.05,
        })
    },
    init(scene) {
        if (Config.isMuted) return
        this.scene = scene
        this.entries = {...scene.cache.audio.entries.entries}
    },
    win() {
        if (Config.isMuted) return
        this.scene?.sound.play('soundGameWin', {
            volume: 0.2,
        })
    },
}

export default audio
